import { render, staticRenderFns } from "./AnswersView.vue?vue&type=template&id=ffef8104&scoped=true"
import script from "./AnswersView.vue?vue&type=script&lang=js"
export * from "./AnswersView.vue?vue&type=script&lang=js"
import style0 from "./AnswersView.vue?vue&type=style&index=0&id=ffef8104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffef8104",
  null
  
)

export default component.exports